// extracted by mini-css-extract-plugin
export default {"checkboxes_title":"Checkboxes_checkboxes_title__QxEZ6","checkboxes_items":"Checkboxes_checkboxes_items__G-qIb","long":"Checkboxes_long__5znzs"};